module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAQCAYAAADESFVDAAAABHNCSVQICAgIfAhkiAAAATZJREFUKJF10T1Lw1AUBuD3PU3FxaERHIQOdXBxqLOri0PBghDo4BQoKQ46iX+hkxXSchsICB2EglsGFzdRwcnVH3EXN5vmuFxL7ccZDw8v54NYU0mS7BdFEZNsllaBfr9fFZEXkoeqWuciiON4u1wufwCoqWohIqcyD9I03fI87xlADQBUNWy329kMjcfjjTzPn0jWHbjpdDr3ACAOlKy1jwCOHLiLoqj7FyAAYK0dkWw48BBF0dX8GGKM6ZFsOZD5vn++uIyQ3Fx3qxmqVCoXqpoBAMmGtXa0hIIgmPq+fwbg1cGWMab3DwFAEAQ/nuedqOqng5fD4fD6HwKAMAy/8zw/BvDlWl1jTAsAlt6SpunuZDJ5J1kFMCXZXEIAMBgM9kTkjeSOqmYrEQAkSXJQFMUtyeYvuVh0gjafTDsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/go_back.png
// module id = 1056
// module chunks = 1